import React, { FC, useState, useEffect } from 'react';
import { ToggleProps } from '.';
import useTranslations from '@hooks/useTranslations';
import { PaymentJourneyTypes } from '../../partExchange/interfaces/Default';
import { AccessibleButton } from '@components/Button/AccessibleButton';

export const ToggleTemplate: FC<ToggleProps> = ({
    optionA,
    optionB,
    className,
    toggled,
    onClick,
    id,
    disabled,
    page,
}) => {
    const [isToggled, setIsToggled] = useState(toggled || false);
    const { t } = useTranslations();

    const handleToggle = () => {
        if (!disabled) {
            setIsToggled(!isToggled);
            if (onClick) {
                isToggled ? onClick(optionA) : onClick(optionB);
            }
        }
    };

    useEffect(() => {
        setIsToggled(toggled);
    }, [toggled]);

    const getToggleTextTranslated = (option: string, long: boolean = false): string => {
        if (option === PaymentJourneyTypes.FINANCE) {
            return long ? t('paymentJourneyType.finance_longText') : t('paymentJourneyType.finance');
        }

        return long ? t('paymentJourneyType.cash_longText') : t('paymentJourneyType.cash');
    };

    return (
        <div className={className} data-testid={id}>
            <div
                className={`toggleHandleContainer ${page === 'home' ? 'toggleHandleContainerFilter' : ''}`}
                onClick={handleToggle}
                id={id}
            >
                <div
                    className={`toggleHandle ${isToggled ? 'toggled' : ''} ${
                        page === 'home' ? 'toggleHandleFilter' : ''
                    }`}
                />
            </div>
            <AccessibleButton
                data-testid="FINANCE"
                className={`toggleOption toggleOption-desktop ${!isToggled ? 'toggled' : ''}`}
            >
                {getToggleTextTranslated(optionA, true)}
            </AccessibleButton>
            <AccessibleButton
                data-testid="CASH"
                className={`toggleOption toggleOption-desktop ${isToggled ? 'toggled' : ''}`}
            >
                {getToggleTextTranslated(optionB, true)}
            </AccessibleButton>
            <AccessibleButton
                data-testid="FINANCE"
                className={`toggleOption toggleOption-mobile ${!isToggled ? 'toggled' : ''}`}
            >
                {getToggleTextTranslated(optionA)}
            </AccessibleButton>
            <AccessibleButton
                data-testid="CASH"
                className={`toggleOption toggleOption-mobile ${isToggled ? 'toggled' : ''}`}
            >
                {getToggleTextTranslated(optionB)}
            </AccessibleButton>
        </div>
    );
};
